import { Typography, Button } from "@mui/material";

const ButtonWithProgress = (props) => {
  const backGroundColorButton = props.backGroundColorButton;
  const disabled = props.disabled;

  return (
    <Button
      disabled={disabled}
      style={{
        backgroundColor: backGroundColorButton,
        color: "white",
        width: "163px",
        height: "57px",
        borderRadius: "4px",
      }}
      size="small"
      variant="contained"
      onClick={props.onClick}
    >
      <Typography
        variant="p"
        style={{
          position: "absolute",
          width: "69px",
          height: "16px",
          left: "47px",
          top: "20px",
          letterSpacing: "1.80px",
          lineHeight: "16px",
          fontStyle: "normal",
          size: "16px",
          fontWeight: "bold",
          Weight: "700",
          fontSize: "16px",
          textTransform: "none",
          fontFamily: "Roboto",
        }}
      >
        {props.text}
      </Typography>
    </Button>
  );
};

export default ButtonWithProgress;
